import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Individual.css";
import "./Payment.css";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
// import SideNav from "./SideNav"; 

const Broadband = () => {
  const [showTracker, setShowTracker] = useState(false);
useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="radial-bg"></div>
      <section className="insurance-service position-relative overflow-hidden">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-3  d-none d-lg-block">
              <div style={{ position: 'relative', height: '100%' }}>
              <SideNav />
            </div>
            </div> */}
            <div className="col-12">
          <div
            className="row justify-content-center text-center"
          >
            <div className="col-12">
              <h2 className="fw-semibold recharge-title">Broadband Recharge</h2>
            </div>
          </div>

          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-8 col-lg-6">
              <div className="card p-4 shadow mb-5 recharge-box mt-5">
                <div className="mb-3">
                  <label className="form-label fw-semibold">Pay Broadband Bill</label>
                  <select className="form-select">
                    <option value="">Select State</option>
                    <option>Andhra Pradesh</option>
                    <option>Assam</option>
                    <option>Bihar</option>
                    <option>Chhattisgarh</option>
                    <option>Delhi</option>
                    <option>Goa</option>
                    <option>Gujrat</option>
                    <option>Haryana</option>
                    <option>Himachal Pradesh</option>
                    <option>Jharkhand</option>
                    <option>Karnataka</option>
                    <option>Kerala</option>
                    <option>Madhya Pradesh</option>
                    <option>Maharashtra</option>
                    <option>Mizoram</option>
                    <option>Odisha</option>
                    <option>Puducherry</option>
                    <option>Punjab</option>
                    <option>Rajasthan</option>
                    <option>Tamil Nadu</option>
                    <option>Telangana</option>
                    <option>Uttarakhand</option>
                    <option>Uttar-Pradesh</option>
                    <option>West Bengal</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Broadband/Landline Operator
                  </label>
                  <select className="form-select">
                    <option value="">Select Operator</option>
                    <option>Catla Broadband</option>
                    <option>Aparna Star TV Network</option>
                    <option>Nageshwar Broadband</option>
                    <option>Isolnet Integrated Solutions</option>
                    <option>RealTel</option>
                    <option>Ethernet Xpress</option>
                    <option>ACT Fibernet</option>
                    <option>Jio Fiber</option>
                    <option>Bsnl</option>
                    <option>Airtel Xstream</option>
                    <option>Airtel Broadband</option>
                    <option>BSNL Broadband</option>
                    <option>Netlink Broadband</option>
                    <option> Hathway Broadband</option>
                    <option> Tikona Broadband</option>
                    <option>You Broadband</option>
                    <option>Spectra</option>
                    <option>Connect Broadband</option>
                    <option>Excitel</option>
                    <option> Asianet Broadband</option>
                    <option>GTPL Broadband</option>
                    <option>Tata Sky Broadband</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Mobile Number</label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Enter your mobile number"
                  />
                </div>
                <div className="d-grid">
                  <button
                    className="btn btn-primary"
                    style={{ fontFamily: "poppins" }}
                  >
                    Processed
                  </button>
                </div>

                <div className="mt-3" style={{ fontFamily: "poppins" }}>
                  <span>Status Pending?</span>
                  <br />
                  <button
                    className="btn btn-link text-decoration-none text-primary fw-semibold d-inline-flex align-items-center gap-1 p-0"
                    onClick={() => setShowTracker(!showTracker)}
                  >
                    Track Your Status now{" "}
                    <i className="bi bi-arrow-right-short fs-5"></i>
                  </button>

                  {showTracker && (
                    <div className="card p-3 mt-2 shadow-sm">
                      <label className="form-label">
                        Landline Operator / Mobile Number
                      </label>
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Enter Number To Track Your Status"
                      />
                      <button
                        className="btn btn-outline-primary"
                        style={{ fontFamily: "poppins" }}
                      >
                        Track Now
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="position-absolute bottom-0 start-0 end-0"
          style={{
            height: "25rem",
            background: "linear-gradient(to top, #F5F2FF, transparent)",
            zIndex: "-1",
          }}
        />
        </div>
        </div>
      </section>
      <Explore />
      <Footer />
    </>
  );
};

export default Broadband;
